import { OxylinkComponents } from './Components/OxylinkComponents';
import { OxylinkApiConfig } from './Configs/OxylinkApiConfig';
import { OxylinkPermissionsConfig } from './Configs/OxylinkPermissionsConfig';
import { IdelinkRoutesConfig } from './Configs/OxylinkRouteConfig';

export class OxylinkSetup {
	public static initialize = () => {
		OxylinkApiConfig.initApiConfig();
		OxylinkComponents.overrideComponents();
		IdelinkRoutesConfig.initRouteMappingConfig();
		OxylinkPermissionsConfig.initPermissionsConfig();
	};
}
